<template>
  <div class="NotificationsSettings">
    
    <LoadingLayout v-if="loading" :page="true" />

    <Page
      v-else
      :title="$t('Settings')"
      :primaryAction="theUser.isDemo ? null : {
        label: $t('Save'),
        onAction: save
      }"
    >
      <Layout>
        <LayoutSection>
          <!-- <Card>
            <CardSection>
              <Checkbox
                v-model="settings.notificationsEnabled"
                :label="$t('NotificationsApp.Enable Manual Notifications?')"
                :help-text="$t('NotificationsApp.notificationEnabledHelp')"
              />
            </CardSection>
          </Card> -->
          <Card>
            <CardSection>
                <Checkbox
                  v-model="settings.sendWelcomeNotification"
                  :label="$t('NotificationsApp.Send Welcome Notification?')"
                  :help-text="$t('NotificationsApp.welcomeNotificationHelp')"
                />
            </CardSection>
          </Card>
          <Card>
            <CardSection>
              <label>{{$t('NotificationsApp.Delivery Window')}}</label>
              <FormLayoutGroup>
                <Select
                  v-model="hoursFrom"
                  :options="hourTimings"
                  :placeholder="$t('From')"
                />
                <Select
                  v-model="hoursTo"
                  :options="hourTimings"
                  :placeholder="$t('To')"
                />
              </FormLayoutGroup>
              <div>{{$t('NotificationsApp.timeWindowMessage')}}</div>
            </CardSection>
          </Card>
          <Card>
            <CardSection>
              <Select
                v-model="daysSelected"
                :multiple="true"
                :options="daysOfWeek"
                tags
                :placeholder="$t('Any day')"
                :label="$t('Day of the week')"
                :text-help="$t('NotificationsApp.selectedDaysMessage')"
              />
            </CardSection>
          </Card>
          <Card>
            <CardSection>
              <Select
                v-model="minHoursBetween"
                :options="timeBetweenOptions"
                :label="$t('NotificationsApp.Time between notifications')"
                :help-text="$t('NotificationsApp.timeBetweenHelp')"
                :placeholder="$t('Choose Time')"
              />
            </CardSection>
          </Card>

          <Card>
            <CardSection>
              <ImageInput
                :label="$t('Default Icon')"
                :required="true"
                v-model="settings.defaultIcon"
                :help-text="$t('NotificationsApp.defaultIconHelp')"
              />
            </CardSection>
          </Card>

          <Card>
            <CardSection>
              <Select
                v-model="defaultTTL"
                :options="ttlOptions"
                :label="$t('NotificationsApp.Time to Expire')"
                :help-text="$t('NotificationsApp.expireHelp')"
                :placeholder="$t('NotificationsApp.Choose Expiry')"
              />
            </CardSection>
          </Card>
          <!-- <Card>
            <CardSection>
              <Button type="primary" @click="save">Save</Button>
            </CardSection>
          </Card> -->
        </LayoutSection>

      </Layout>
    </Page>

  </div>
</template>

<script>

import ImageInput from '../../../components/ui/ImageInput'

export default {
  name: 'NotificationsSettings',
  data() {
    return {
      loading: true,
      settings: {
        notificationsEnabled: true,
        sendWelcomeNotification: true,
        minHoursBetween: 0,
        onlyDeliverInTZ: {
          hoursFrom: '00:00',
          hoursTo: '24:00',
          days: [0, 1, 2, 3, 4, 5, 6]
        },
        defaultIcon: '',
        defaultTTL: 60 * 60 * 24
      },
      daysSelected: [],
      hoursFrom: null,
      hoursTo: null,
      minHoursBetween: null,
      defaultTTL: null
    }
  },
  mounted() {
    // load settings
    this.loading = true
    NProgress.start()
    this.api.notifications.getSettings()
      .then((response) => {
        if (response.settings[0]) {
          this.$set(this, 'settings', response.settings[0])
          if (!this.settings.onlyDeliverInTZ) {
            this.$set(this.settings, 'onlyDeliverInTZ', {
              hoursFrom: '00:00',
              hoursTo: '24:00',
              days: [0, 1, 2, 3, 4, 5, 6],
            })
          }
        }

        this.hoursFrom = this.settings.onlyDeliverInTZ.hoursFrom
        this.hoursTo = this.settings.onlyDeliverInTZ.hoursTo

        this.daysSelected = this.settings.onlyDeliverInTZ.days || []

        this.minHoursBetween = this.settings.minHoursBetween
        this.defaultTTL = this.settings.defaultTTL

        this.loading = false

        this.$nextTick(() => {
          if (this.$refs['image-thumb']) {
            this.$refs['image-thumb'].style.minHeight = '100%'
          }
        })
      })
      .catch((error) => {
        this.apiCatch(error.message)
      })
      .finally(() => {
        NProgress.done()
      })
  },
  methods: {
    save() {
      this.settings.onlyDeliverInTZ.hoursFrom = this.hoursFrom
      this.settings.onlyDeliverInTZ.hoursTo = this.hoursTo
      this.settings.onlyDeliverInTZ.days = this.daysSelected
      this.settings.minHoursBetween = this.minHoursBetween
      this.settings.defaultTTL = this.defaultTTL

      NProgress.start()
      this.api.notifications.updateSettings(this.settings)
        .then(() => {
          this.$ui.toast({ title: this.$t('Settings saved') })
        })
        .catch((error) => {
          this.apiCatch(error.message)
        })
        .finally(() => {
          NProgress.done()
        })
    },
  },
  computed: {
    hourTimings() {
      return [
        { value: '00:00', label: this.$t('Midnight') },
        { value: '01:00', label: '1 AM' },
        { value: '01:30', label: '1:30 AM' },
        { value: '02:00', label: '2 AM' },
        { value: '02:30', label: '2:30 AM' },
        { value: '03:00', label: '3 AM' },
        { value: '03:30', label: '3:30 AM' },
        { value: '04:00', label: '4 AM' },
        { value: '04:30', label: '4:30 AM' },
        { value: '05:00', label: '5 AM' },
        { value: '05:30', label: '5:30 AM' },
        { value: '06:00', label: '6 AM' },
        { value: '06:30', label: '6:30 AM' },
        { value: '07:00', label: '7 AM' },
        { value: '07:30', label: '7:30 AM' },
        { value: '08:00', label: '8 AM' },
        { value: '08:30', label: '8:30 AM' },
        { value: '09:00', label: '9 AM' },
        { value: '09:30', label: '9:30 AM' },
        { value: '10:00', label: '10 AM' },
        { value: '10:30', label: '10:30 AM' },
        { value: '11:00', label: '11 AM' },
        { value: '11:30', label: '11:30 AM' },
        { value: '12:00', label: this.$t('Midday') },
        { value: '12:30', label: '12:30 PM' },
        { value: '13:00', label: '1 PM' },
        { value: '13:30', label: '1:30 PM' },
        { value: '14:00', label: '2 PM' },
        { value: '14:30', label: '2:30 PM' },
        { value: '15:00', label: '3 PM' },
        { value: '15:30', label: '3:30 PM' },
        { value: '16:00', label: '4 PM' },
        { value: '16:30', label: '4:30 PM' },
        { value: '17:00', label: '5 PM' },
        { value: '17:30', label: '5:30 PM' },
        { value: '18:00', label: '6 PM' },
        { value: '18:30', label: '6:30 PM' },
        { value: '19:00', label: '7 PM' },
        { value: '19:30', label: '7:30 PM' },
        { value: '20:00', label: '8 PM' },
        { value: '20:30', label: '8:30 PM' },
        { value: '21:00', label: '9 PM' },
        { value: '21:30', label: '9:30 PM' },
        { value: '22:00', label: '10 PM' },
        { value: '22:30', label: '10:30 PM' },
        { value: '23:00', label: '11 PM' },
        { value: '23:30', label: '11:30 PM' },
        { value: '24:00', label: this.$t('Midnight') },
      ]
    },
    daysOfWeek() {
      return [
        { value: 0, label: this.$t('Sunday') },
        { value: 1, label: this.$t('Monday') },
        { value: 2, label: this.$t('Tuesday') },
        { value: 3, label: this.$t('Wednesday') },
        { value: 4, label: this.$t('Thursday') },
        { value: 5, label: this.$t('Friday') },
        { value: 6, label: this.$t('Saturday') },
      ]
    },
    timeBetweenOptions() {
      return [
        { value: 0, label: this.$t('None') },
        { value: 1, label: this.$t('1 Minute') },
        { value: 3, label: this.$t('numberOfMinutes', { count: '3' }) },
        { value: 5, label: this.$t('numberOfMinutes', { count: '5' }) },
        { value: 10, label: this.$t('numberOfMinutes', { count: '10' }) },
        { value: 15, label: this.$t('numberOfMinutes', { count: '15' }) },
        { value: 30, label: this.$t('numberOfMinutes', { count: '30' }) },
        { value: 60, label: this.$t('1 Hour') },
        { value: 120, label: this.$t('numberOfHours', { count: '2' }) },
        { value: 180, label: this.$t('numberOfHours', { count: '3' }) },
        { value: 360, label: this.$t('numberOfHours', { count: '6' }) },
        { value: 720, label: this.$t('numberOfHours', { count: '12' }) },
        { value: 1440, label: this.$t('numberOfHours', { count: '24' }) },
      ]
    },
    ttlOptions() {
      return [
        { value: 60 * 60 * 24, label: this.$t('numberOfHours', { count: '24' }) },
        { value: 60 * 60 * 24 * 2, label: this.$t('numberOfDays', { count: '2' }) },
        { value: 60 * 60 * 24 * 3, label: this.$t('numberOfDays', { count: '3' }) },
        { value: 60 * 60 * 24 * 4, label: this.$t('numberOfDays', { count: '4' }) },
        { value: 60 * 60 * 24 * 5, label: this.$t('numberOfDays', { count: '5' }) },
        { value: 60 * 60 * 24 * 6, label: this.$t('numberOfDays', { count: '6' }) },
        { value: 60 * 60 * 24 * 7, label: this.$t('numberOfDays', { count: '7' }) }
      ]
    }
  },
  components: {
    ImageInput
  }
};
</script>

<style lang="less">
  .info {
    background: #eee;
    padding: 10px;
    font-size: 90%;
    margin-bottom: 20px;
  }
  .delivery-window {
    .delivery-window__seperator {
      background: #e9ecef;
      border: 1px solid #ced4da;
      border-left: none;
      border-right: none;
      text-align: center;
      padding-top: 7px;
      width: 30px;
    }
  }
  .image-thumb {
    float: left;
    clear: left;
    margin-top: 15px;
    border: 5px solid #ccc;
    width: 250px;
    height: 100%;
  }
  .form-spacer {
    width: 100%;
    height: 25px;
  }
</style>
